import React from "react";

function Alien() {

    return (
    
        <g id="alien">
            <iframe 
                src="https://giphy.com/embed/3oKIPpUIYNsbrqEZSU" 
                width="844" 
                height="475"
                frameBorder="0" 
            >
            </iframe>
        </g>

    )

}

export default Alien 